/* Polymount — temats globala skript.
   Utbrutet ur layout/theme.liquid av hand. Ingen liquid har inne, sa filen ar
   identisk for varje sida och kan cachas. Till skillnad fran CSS finns ingen kaskad
   att tappa: ett skript beter sig likadant oavsett var det laddas ifran.

   Kvar inline ligger reveal-koden, som laser temainstallningar. */

/* Reference-counted scroll lock shared by every popup, drawer & modal.
     Counter means overlapping popups don't unlock the page until the LAST one closes.
     Uses the position:fixed technique because iOS Safari ignores overflow:hidden for touch
     scrolling — the desktop-only overflow rule wasn't enough on a real phone. */
  (function () {
    var n = 0, root = document.documentElement, body = document.body, y = 0;
    function apply() {
      y = window.scrollY || window.pageYOffset || 0;
      body.style.position = 'fixed';
      body.style.top = (-y) + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
      root.classList.add('pm-locked');
    }
    function release() {
      root.classList.remove('pm-locked');
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      var prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';        // don't smooth-scroll back to the saved spot
      window.scrollTo(0, y);
      root.style.scrollBehavior = prev;
    }
    window.pmScrollLock = {
      lock: function () { if (n === 0) apply(); n++; },
      unlock: function () { n = Math.max(0, n - 1); if (n === 0) release(); },
      reset: function () { if (n > 0) release(); n = 0; }
    };
  })();
  

  /* Background-pattern parallax — moves the pattern layer slower than the page.
     Elementen samlas OM vid varje sektionsomladdning, precis som lager-parallaxen nedanfor.
     Den gamla versionen samlade en gang och gav upp om listan var tom — i editorn byts
     sektionens DOM vid varje sparning, sa listan pekade pa doda noder, och slogs parallaxen
     pa efter sidladdningen fanns det ingenting att hitta. Den bet darfor aldrig dar. */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    /* Lagret slas upp vid insamlingen, inte varje bildruta. Och alla LASNINGAR gors fore
       alla SKRIVNINGAR — omlott tvingar de fram en ny stilberakning per monster och ruta,
       vilket ar precis den sortens jank skriptet self skapade nar det vaknade. */
    var els = [];
    function collect() {
      els = Array.prototype.slice.call(document.querySelectorAll('[data-pat-parallax]')).map(function (el) {
        return { el: el, l: el.querySelector('.secpat__l'), sp: parseFloat(el.getAttribute('data-pat-parallax')) || 3 };
      }).filter(function (p) { return p.l; });
    }
    var ticking = false;
    function tick() {
      var vh = window.innerHeight;
      var jobb = [];
      els.forEach(function (p) {
        var r = p.el.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) { return; }
        jobb.push([p.l, ((r.top + r.height / 2) - vh / 2) * (p.sp / 12) * -1]);
      });
      jobb.forEach(function (j) { j[0].style.transform = 'translateY(' + j[1].toFixed(1) + 'px)'; });
      ticking = false;
    }
    function onScroll() { if (!els.length || ticking) { return; } ticking = true; requestAnimationFrame(tick); }
    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    tick();
    document.addEventListener('shopify:section:load', function () { collect(); tick(); });
  })();

  /* Layered parallax — background image drifts down + slowly zooms, while foreground
     content counter-drifts up and fades out for cinematic depth. Compositor-only
     transforms, rAF-throttled, off-screen sections skipped, off under reduced-motion.
     Opt-in: data-parallax-bg="<px>" (image container) / data-parallax-fg="<px>" (content). */
  (function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var bg = [], fg = [], frame = [];
    function collect() {
      bg = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-bg]'));
      fg = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-fg]'));
      frame = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-frame]'));
    }
    function seen(r, vh) { return !(r.bottom < -80 || r.top > vh + 80); }
    /* t rises from -1 (section entering from below) through 0 (centred) to 1 (exiting top) */
    function tOf(r, vh) {
      var t = (vh / 2 - (r.top + r.height / 2)) / (vh / 2 + r.height / 2);
      return t > 1 ? 1 : (t < -1 ? -1 : t);
    }
    var ticking = false;
    function tick() {
      /* Lasfas: mat allt. Skrivfas: applicera allt. Blandat tvingar varje par fram en ny
         stilberakning — med tre listor och flera element blev det dussintals per bildruta. */
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var skriv = [];
      bg.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (!seen(r, vh)) return;
        var layer = el.querySelector('img, picture, video');
        if (!layer) return;
        var sp = parseFloat(el.getAttribute('data-parallax-bg')) || 20;
        var t = tOf(r, vh);
        var zoom = 1 + ((t + 1) / 2) * 0.09;
        skriv.push([layer, 'translate3d(0,' + (t * sp).toFixed(1) + 'px,0) scale(' + zoom.toFixed(3) + ')', null]);
      });
      fg.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (!seen(r, vh)) return;
        var sp = parseFloat(el.getAttribute('data-parallax-fg')) || 30;
        var t = tOf(r, vh);
        skriv.push([el, 'translate3d(0,' + (t * -sp).toFixed(1) + 'px,0)', (t > 0 ? Math.max(0.1, 1 - t * 0.9) : 1).toFixed(2)]);
      });
      /* Framed images: transform-only (image stays in flow, no layout change) — a base
         scale gives headroom so the drift never reveals the frame edge. */
      frame.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (!seen(r, vh)) return;
        var layer = el.querySelector('img, picture, video');
        if (!layer) return;
        var sp = parseFloat(el.getAttribute('data-parallax-frame')) || 24;
        var t = tOf(r, vh);
        var base = 1.1;
        var zoom = base + ((t + 1) / 2) * 0.05;
        /* never drift past the scaled headroom, whatever the strength setting */
        var maxDrift = (base - 1) / 2 * r.height * 0.85;
        var drift = t * sp;
        if (drift > maxDrift) { drift = maxDrift; } else if (drift < -maxDrift) { drift = -maxDrift; }
        skriv.push([layer, 'translate3d(0,' + drift.toFixed(1) + 'px,0) scale(' + zoom.toFixed(3) + ')', null]);
      });
      skriv.forEach(function (s) {
        s[0].style.transform = s[1];
        if (s[2] !== null) { s[0].style.opacity = s[2]; }
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    tick();
    document.addEventListener('shopify:section:load', function () { collect(); tick(); });
  })();

  /* Scroll smoothness: pause continuous (infinite) decorative animations while off-screen,
     so the compositor isn't repainting marquees / dividers / stickers you can't see. */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var SEL = '.lb__track, .announcement__track, .filmstrip__track, .sdvd[data-anim="true"] .sdvd__inner, .stk[data-anim="spin"] .stk__anim, .stk[data-anim="float"] .stk__anim, .stk[data-anim="drift"] .stk__anim, .stk[data-anim="twinkle"] .stk__anim';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.target.style.animationPlayState = e.isIntersecting ? 'running' : 'paused'; });
    }, { rootMargin: '160px' });
    function init(root) { (root || document).querySelectorAll(SEL).forEach(function (el) { io.observe(el); }); }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  /* Accent-word underline: draw the hand line when the word scrolls into view. */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.hl--u').forEach(function (e) { e.classList.add('is-drawn'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-drawn'); io.unobserve(en.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -32% 0px' });
    /* Sit the line just under the word's real ink, measured per font+string via canvas metrics.
       CSS has no descender unit, so a fixed em offset collides with deep-descender fonts. */
    var mctx = null;
    function fitDrop(el) {
      try {
        if (!mctx) { mctx = document.createElement('canvas').getContext('2d'); }
        var cs = getComputedStyle(el);
        var fs = parseFloat(cs.fontSize) || 16;
        mctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        var m = mctx.measureText((el.textContent || '').trim() || 'x');
        var desc = m.actualBoundingBoxDescent;
        if (typeof desc !== 'number' || !isFinite(desc)) { return; }
        /* content-box bottom already sits at the font's descent; nudge past the ink plus a small gap */
        var fdesc = m.fontBoundingBoxDescent;
        if (typeof fdesc !== 'number' || !isFinite(fdesc)) { fdesc = desc; }
        var drop = (desc - fdesc) + fs * 0.38;
        el.style.setProperty('--hl-drop', drop.toFixed(1) + 'px');
        /* The line is absolutely positioned, so it hangs outside the heading box and would overlap
           whatever follows (a CTA, body copy). Reserve exactly that much room under the heading. */
        var host = el.closest('h1, h2, h3, .hero__heading, .mega__line');
        if (host) { host.style.paddingBottom = Math.max(0, drop + fs * 0.22).toFixed(1) + 'px'; }
      } catch (e) {}
    }
    function prep(el) {
      var p = el.querySelector('.hl__u path');
      if (p) { try { el.style.setProperty('--hl-len', p.getTotalLength()); } catch (e) {} }
      fitDrop(el);
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { fitDrop(el); }); }
    }
    function init(root) {
      (root || document).querySelectorAll('.hl--u:not(.is-drawn)').forEach(function (el) {
        prep(el);
        if (reduce) { el.classList.add('is-drawn'); } else { io.observe(el); }
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  /* Count-up: animate a number from 0 to its target when it scrolls into view.
     Opt-in: data-countup="<number>" (+ optional data-prefix / data-suffix). */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fmt(n, dec) {
      var s = dec > 0 ? n.toFixed(dec) : Math.round(n).toString();
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    }
    function run(el) {
      var raw = el.getAttribute('data-countup');
      var target = parseFloat(raw);
      if (isNaN(target)) { return; }
      var dec = (raw.split('.')[1] || '').length;
      var pre = el.getAttribute('data-prefix') || '';
      var suf = el.getAttribute('data-suffix') || '';
      if (reduce) { el.textContent = pre + fmt(target, dec) + suf; return; }
      var dur = 1500, start = null;
      function step(ts) {
        if (start === null) { start = ts; }
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = pre + fmt(target * eased, dec) + suf;
        if (p < 1) { requestAnimationFrame(step); } else { el.textContent = pre + fmt(target, dec) + suf; }
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-countup]').forEach(run);
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    function init(root) {
      (root || document).querySelectorAll('[data-countup]:not([data-counted])').forEach(function (el) {
        el.setAttribute('data-counted', '1'); io.observe(el);
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

/* ---- Stilla-grinden ----
   Allt arbete som far vanta — forhamtning och avkodning av bilder, varmning av gallerier —
   MASTE ga genom den har. Den kor uppgiften forst nar (a) ingen scroll skett pa 400 ms och
   (b) webblasaren sjalv sager att den ar ledig. Bakgrund: uppvarmningen av galleriet
   hamtade och avkodade bilder strax efter load, och den som borjade scrolla da fick hack pa
   alla butiker. scripts/scrollvakt.py faller utrullningen om bildarbete i bakgrunden
   forekommer utan att filen anvander grinden. */
(function () {
  var sist = 0;
  window.addEventListener('scroll', function () { sist = performance.now(); }, { passive: true });
  window.addEventListener('touchmove', function () { sist = performance.now(); }, { passive: true });
  window.pmNarStilla = function (fn) {
    if (performance.now() - sist < 400) { setTimeout(function () { window.pmNarStilla(fn); }, 250); return; }
    (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(fn, { timeout: 3000 });
  };
})();
